{
  "header": {
    "title": "Einstellungen",
    "description": "Verwalten Sie Ihre Präferenzen, Benachrichtigungen und Zugriffseinstellungen, um Ihre Chirpee-Erfahrung anzupassen"
  },
  "tabs": {
    "workplace": {
      "title": "Arbeitsplatz",
      "logo": "Arbeitsplatz-Logo",
      "changeLogo": "Logo ändern",
      "logoEmptyState": "Noch kein Logo hochgeladen",
      "logoValidation": {
        "invalidFormat": "Bitte wählen Sie ein PNG-, JPEG-, GIF- oder WebP-Bild.",
        "fileTooLarge": "Das Bild darf höchstens 5 MB groß sein.",
        "dimensionsTooLarge": "Das Bild darf höchstens 4096 × 4096 Pixel groß sein.",
        "loadFailed": "Dieses Bild konnte nicht gelesen werden. Versuchen Sie eine andere Datei."
      },
      "logoUploadErrorFallback": "Logo konnte nicht hochgeladen werden. Bitte erneut versuchen.",
      "maxSize": "Max. 5 MB · max. 4096 × 4096 px",
      "format": "PNG, JPEG, GIF oder WebP",
      "worplaceNameInput": {
        "label": "Name des Arbeitsplatzes",
        "placeholder": "Name des Arbeitsplatzes"
      },
      "companyIndustryInput": {
        "label": "Branche des Unternehmens",
        "placeholder": "Branche des Unternehmens",
        "industries": {
          "technology": "Technologie",
          "professionalServices": "Professionelle Dienstleistungen",
          "financialServices": "Finanzdienstleistungen",
          "consulting": "Beratung",
          "softwareDevelopment": "Softwareentwicklung",
          "digitalMarketing": "Digitales Marketing",
          "mediaAndCommunications": "Medien und Kommunikation",
          "eCommerce": "E-Commerce",
          "healthTech": "Gesundheitstechnologie"
        }
      },
      "languguages": {
        "title": "Unterstützte Sprachen",
        "helpText": "Hilfetext"
      },
      "applyButton": "Änderungen übernehmen"
    },
    "userManagement": {
      "title": "Benutzerverwaltung",
      "userInput": {
        "placeholder": "Benutzer suchen"
      },
      "roleDropdown": {
        "triggerLabel": "Rolle",
        "options": {
          "admin": "Administrator",
          "people_experience": "Mitarbeitenden-Erfahrung",
          "user": "Benutzer"
        }
      }
    },
    "integrations": {
      "title": "Integrationen",
      "options": {
        "hris": { "label": "HRIS" },
        "sso": { "label": "Single Sign-On (SSO)" },
        "messagingConnected": { "label": "Kommunikationstool" }
      }
    },
    "billing": {
      "title": "Abrechnung",
      "planSection": {
        "title": "Ihr Plan",
        "status": {
          "active": "Aktiv"
        },
        "usersCount": {
          "title": "Monatliche Benutzer"
        },
        "amount": {
          "title": "Verlängerungsbetrag",
          "cost": "pro Benutzer"
        },
        "charge": {
          "title": "Nächste Abrechnung"
        },
        "cycle": {
          "title": "Abrechnungszeitraum"
        }
      },
      "invoiceInformationSection": {
        "title": "Rechnungsinformationen",
        "name": "Firmenname",
        "email": "Rechnungs-E-Mail",
        "address": "Firmenadresse",
        "taxId": "Steuernummer",
        "paymentMethod": "Zahlungsmethode",
        "paymentDate": "Letztes Zahlungsdatum",
        "editButton": "Bearbeiten",
        "portalError": "Das Abrechnungsportal konnte nicht geöffnet werden. Bitte versuchen Sie es erneut."
      },
      "invoiceHistorySection": {
        "title": "Rechnungshistorie",
        "viewButton": "Ansehen",
        "downloadButton": "Herunterladen",
        "emptyState": {
          "title": "Noch keine Rechnungen",
          "description": "Rechnungen erscheinen hier nach Ihrer ersten erfolgreichen Zahlung."
        }
      },
      "errorState": {
        "title": "Abrechnungsdaten konnten nicht geladen werden",
        "description": "Bitte aktualisieren Sie die Seite und versuchen Sie es erneut."
      }
    },
    "logs": {
      "title": "Prüfprotokolle",
      "table": {
        "title": "Letzte Aktivitäten",
        "acitivityDropdown": {
          "triggerLabel": "Alle Aktivitäten"
        },
        "usersDropdown": {
          "triggerLabel": "Alle Benutzer"
        },
        "exportButton": "Protokolle exportieren"
      }
    }
  },
  "columns": {
    "name": "Name",
    "department": "Abteilung",
    "role": "Rolle",
    "active": "Zuletzt aktiv"
  },
  "settingsBillingInvoiceHistorySection": {
    "date": "Zahlungsdatum",
    "status": "Status",
    "amount": "Betrag",
    "actions": "",
    "view": "Ansehen",
    "download": "Herunterladen"
  },
  "settingsLogsActivitySection": {
    "date": "Zahlungsdatum",
    "activity": "Aktivität",
    "user": "Benutzer"
  },
  "dateLabels": {
    "thisMonth": "Diesen Monat",
    "lastMonth": "Letzten Monat",
    "monthsAgo": "Vor {{count}} Monaten"
  }
}
